<template>
  <v-app id="inspire">
    <v-navigation-drawer
      :mini-variant.sync="miniVariant"
      v-model="drawer"
      enable-resize-watcher
      app
      ref="customMenu"
    >

      <v-list >
        <div v-for="(link, i) in menu" :key="i">
          <v-list-tile
            v-if="link.type === 'link'"
            @click="go(link.component)"
          >
          <!-- v-role="{ rights: link.rights, user: $store.state.auth.roles }" -->
            <v-list-tile-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <!-- <v-list-tile-title>{{ $t(link.lang) }}</v-list-tile-title> -->
              <v-list-tile-title>
                {{ link.title }}
                <v-chip v-if="link.count >= 0" class="navigation-title-chip ml-1" label text-color="blue">
                  {{ getCounter(link.component) }}
                </v-chip>
                <v-chip v-if="link.additional" class="navigation-title-chip" label text-color="white" color="orange">
                  {{ link.additional }}
                </v-chip>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-if="link.type === 'divider'"></v-divider>
          <v-subheader
            v-if="link.type === 'header'"
            :key="link.header"
          >
            {{ link.title }}
          </v-subheader>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="primary" dark fixed app :clipped-left="clipped">
      <v-toolbar-side-icon @click.stop="toggleMenu"></v-toolbar-side-icon>
      <img
        src="@/assets/img/logo/logo-beta.png"
        class="logo ml-4"
      >
      <!-- <v-toolbar-title>{{ titleApp }}</v-toolbar-title> -->

      <v-text-field class="searchWidth"
            :class="{ ml_150: moveSearch }"
           label="Search"
           append-icon="search"
           single-line
           hide-details
           light
           solo
           height="30"
           color="#000"
           background-color="#fff"
         ></v-text-field>
         <v-spacer></v-spacer>
      <!-- {{ $store.state.lang.locale }}
      <v-menu bottom left>
        <v-btn
          slot="activator"
          dark
          icon
        >
          <v-icon>language</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, i) in languages"
            :key="i"
            @click="changeLang(item)"
          >
            <v-list-tile-title>{{ $t(item) }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu> -->
      <v-menu
        v-model="userMenu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
        :right="true"
      >
        <v-btn
          icon
          fab
          slot="activator"
          class="mr-0"
        >
          <i class="material-icons">
            account_circle
          </i>
        </v-btn>

        <v-card class="customMenu">
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <i class="material-icons green--text">
                  account_circle
                </i>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{this.$store.state.user.fullname}}</v-list-tile-title>
                <v-list-tile-sub-title>{{this.$store.state.user.email}}</v-list-tile-sub-title>
              </v-list-tile-content>

            </v-list-tile>
          </v-list>

          <v-divider></v-divider>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <i class="material-icons light-blue--text">
                  info
                </i>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>Quotas</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-card-text class="py-0">
              Projects: {{this.$store.state.user.projects_count}} / {{this.$store.state.user.permissions.max_projects}}
            </v-card-text>
            <v-flex d-flex xs12 sm12 md12 class="mr_b-10">
              <v-card-text class="py-0">
                <v-progress-linear
                  height="5"
                  :value="percentageProjectsCount"
                ></v-progress-linear>
              </v-card-text>
            </v-flex>
            <v-card-text class="py-0">
              Keywords: {{this.$store.state.user.keywords_count}} / {{this.$store.state.user.permissions.max_keywords}}
            </v-card-text>
            <v-flex d-flex xs12 sm12 md12 class="mr_b-10">
              <v-card-text class="py-0">
                <v-progress-linear
                  color="info"
                  height="5"
                  :value="percentageKeywordsCount"
                ></v-progress-linear>
              </v-card-text>
            </v-flex>
            <v-card-text class="py-0">
              Links: {{this.$store.state.user.links_count}} / {{this.$store.state.user.permissions.max_links}}
            </v-card-text>
            <v-flex d-flex xs12 sm12 md12 class="mr_b-10">
              <v-card-text class="py-0">
                <v-progress-linear
                  color="info"
                  height="5"
                  :value="percentageLinksCount"
                ></v-progress-linear>
              </v-card-text>
            </v-flex>
          <v-divider></v-divider>

          <v-list-tile avatar>
            <v-list-tile-avatar>
              <i class="material-icons light-blue--text">
                account_balance_wallet
              </i>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>Koins: {{this.$store.state.user.credits}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="logout()" class="orange--text">
              <v-icon>exit_to_app</v-icon>
              Logout
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-menu
        :close-on-content-click="false"
        :nudge-left="70"
        offset-x
        offset-y
      >
      <v-btn icon fab slot="activator" class="ml-0">
        <v-icon>notifications</v-icon>
      </v-btn>
        <v-card>
          <v-list class="customNotification">
            <!-- <v-list-tile>
              <v-list-tile-action>
                <v-icon color="teal darken-2">email</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>New messages</v-list-tile-title>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="teal darken-2">present_to_all</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>hints</v-list-tile-title>
            </v-list-tile>
            <v-divider></v-divider> -->

            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="teal darken-2">done</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>No notifications</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
      <v-btn icon fab slot="activator">
        <v-icon>notifications</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span>&copy; {{ year }} - Kol-Yom</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'ToolbarComponent',
  data () {
    return {
      clipped: true,
      fixed: false,
      drawer: true,
      miniVariant: false,
      year: (new Date()).getFullYear(),
      titleApp: '',
      languages: [],
      sum: 150,
      userMenu: false,
      message: false,
      hints: true,
      moveSearch: true,
      menu: [
        {
          type: 'header',
          title: 'Main Navigation:'
        },
        {
          type: 'link',
          icon: 'dashboard',
          title: 'Dashboard',
          // lang: 'main_menu.crm',
          component: 'Dashboard',
          additional: 'Beta',
          rights: ['manager', 'admin', 'guest', 'client']
        },
        {
          type: 'link',
          icon: 'timeline',
          title: 'Site Insights',
          component: 'SiteInsights',
          additional: 'Beta',
          rights: ['manager', 'admin', 'guest', 'client']
        },
        {
          type: 'link',
          icon: 'icon-bar-chart',
          title: 'Weather',
          // lang: 'main_menu.crm',
          component: 'Weather',
          additional: 'Beta',
          rights: ['manager', 'admin', 'guest', 'client']
        },
        {
          type: 'link',
          icon: 'folder_open',
          title: 'My Projects',
          // lang: 'main_menu.crm',
          component: 'MyProjects',
          count: true,
          rights: ['manager', 'admin', 'guest', 'client']
        },
        {
          type: 'link',
          icon: 'icon-link',
          title: 'My Links',
          count: true,
          additional: 'Beta',
          // lang: 'main_menu.crm',
          component: 'MyLinks',
          rights: ['manager', 'admin', 'guest', 'client']
        },
        {
          type: 'link',
          icon: 'icon-docs',
          title: 'My Reports',
          additional: 'Beta',
          count: true,
          // lang: 'main_menu.crm',
          component: 'MyReports',
          rights: ['manager', 'admin', 'guest', 'client']
        }
      ],
      topMenu: [
        {
          text: 'Кошелек',
          link: 'balance'
        },
        {
          text: 'Профиль',
          link: 'profile'
        },
        {
          text: 'Выйти',
          link: 'logout'
        }
      ]
    }
  },
  props: {
    source: String
  },
  computed: {
    MyProjects () {
      return this.$store.state.user.projects_count
    },
    MyLinks () {
      return this.$store.state.user.links_count
    },
    MyReports () {
      return this.$store.state.user.reports_count
    },
    percentageProjectsCount () {
      return this.$store.state.user.projects_count * 100 / this.$store.state.user.permissions.max_projects
    },
    percentageKeywordsCount () {
      return this.$store.state.user.keywords_count * 100 / this.$store.state.user.permissions.max_keywords
    },
    percentageLinksCount () {
      return this.$store.state.user.links_count * 100 / this.$store.state.user.permissions.max_links
    }
  },
  mounted () {
    // this.languages = this.$store.state.lang.languages
    this.titleApp = this.$store.state.settings.appName
  },
  methods: {
    getCounter (componentName) {
      return this[componentName]
    },
    go (dest) {
      this.$router.push({name: dest})
    },
    logout () {
      this.$store.dispatch('LOGOUT')
    },
    changeLang (val) {
      let params = { lang: val }
      this.$router.push({name: this.$router.name, params: params})
    },
    toggleMenu () {
      let menuEl = this.$refs.customMenu
      if (!menuEl.isMobile) {
        this.miniVariant = !this.miniVariant
      } else {
        this.drawer = !this.drawer
      }
      this.moveSearch = !this.moveSearch
    }
  }
}
</script>

<style>

</style>

<style src="./style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/toolbar/ToolbarComponent.vue